import React from "react";
import {SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export class BrokenLinkIcon extends React.Component {
    render() {
        return (
            <SvgIcon {...this.props}>
               <g transform="translate(3.333 4.996) scale(0.5)">
                  <path fill="currentColor" d="M23.356,33a.717.717,0,0,1-.483-.317L4.239,4.4a1,1,0,0,1,.133-1.217.633.633,0,0,1,1,.133L23.939,31.6a.983.983,0,0,1-.133,1.217.633.633,0,0,1-.45.183Z" transform="translate(-0.606 -2.998)" />
                  <path fill="currentColor" d="M17.483,18.333A4.267,4.267,0,0,1,13.85,20.95H7.517C5.15,20.95,3.2,18.433,3.2,15.383v-.767c0-3.067,1.95-5.567,4.317-5.583H11.65L10.683,7.5H7.517C4.483,7.533,2,10.733,2,14.65v.767c0,3.9,2.483,7.1,5.517,7.117H13.85a5.25,5.25,0,0,0,4.4-2.933Z" transform="translate(-2 0.004)" />
                  <path fill="currentColor" d="M28.5,15.67a7.8,7.8,0,0,0-1.75-5,5.6,5.6,0,0,0-4.217-2.1h-6.85A5.283,5.283,0,0,0,12.25,9.953l.8,1.217a4.1,4.1,0,0,1,2.633-1.05h6.85A5.217,5.217,0,0,1,27.2,15.687v.767a5.183,5.183,0,0,1-4.667,5.567h-2.5l1,1.55h1.5c3.333,0,5.95-3.2,5.967-7.117Z" transform="translate(4.833 0.717)" />
               </g>
            </SvgIcon>
        );
    }
}
